const REPAIR_ITEM_STATUS_LABELS = {
  PENDING: '待處理',
  IN_PROGRESS: '處理中',
  REPAIRED: '已修好',
  REFUSED: '拒修',
  CLOSED: '已結案',
};

export const REPAIR_ITEM_STATUS_FILTER_OPTIONS = [
  { value: 'PENDING', label: '待處理' },
  { value: 'IN_PROGRESS', label: '處理中' },
  { value: 'REPAIRED', label: '已修好' },
  { value: 'REFUSED', label: '拒修' },
  { value: 'CLOSED', label: '已結案' },
];

export function getRepairItemStatusLabel(status) {
  if (status == null || status === '') {
    return '—';
  }
  return REPAIR_ITEM_STATUS_LABELS[status] ?? status;
}
